export const OTHER_CODE = 'OTHER'

export const sortWithOtherLast = <T>(
    items: T[],
    label: (item: T) => string,
    isOther: (item: T) => boolean,
): T[] =>
    [...items].sort(
        (a, b) => Number(isOther(a)) - Number(isOther(b)) || label(a).localeCompare(label(b)),
    )
